"use strict";
/*
 * Contains helper functions for sorting arrays of objects.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.descendingBy = exports.ascendingBy = void 0;
/**
 * A comparer function for sorting an array of objects by a given property in ascending order.
 * @param attribute Object's attribute name to sort by.
 * @example array.sort(ascendingBy("name"))
 * @link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/sort#description
 */
const ascendingBy = (attribute) => {
    return (a, b) => {
        if (a[attribute] < b[attribute]) {
            return -1; // a before b
        }
        else if (a[attribute] > b[attribute]) {
            return 1; // a after b
        }
        return 0; // keep original order
    };
};
exports.ascendingBy = ascendingBy;
/**
 * A comparer function for sorting an array of objects by a given property in descending order.
 * @param attribute Object's attribute name to sort by.
 * @example array.sort(descendingBy("name"))
 * @link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/sort#description
 */
const descendingBy = (attribute) => {
    return (a, b) => {
        if (a[attribute] > b[attribute]) {
            return -1; // a after b
        }
        else if (a[attribute] < b[attribute]) {
            return 1; // a before b
        }
        return 0; // keep original order
    };
};
exports.descendingBy = descendingBy;
//# sourceMappingURL=array-sort-by.js.map